<template>
  <div class="fill-height">
    <MomentumScrolling :content-classes="{'paper-background': true, 'pt-16': true}">
      <Scribbles :num="8" />
      <v-row class="py-16" :style="{width: '80%', marginLeft: '10%', paddingTop: '120px'}">
          <v-col :cols="12 / columns" v-for="colIndex in columns" :key="colIndex">
            <PhotoExhibitionGridElement
              @mouseenter="overElement = $event"
              @mouseleave="overElement = null"
              v-for="(element, i) in gridViewColElements(colIndex, columns)"
              :key="i"
              :data="element"
              :container-columns="columns"
              class="grid-element my-6"
              :class="{deselected: !!overElement && element.photos.indexOf(overElement) === -1}"
              position="center"
              :style="{cursor: 'pointer'}"
              @click="onElementClick(element)"
            />
          </v-col>
      </v-row>
    </MomentumScrolling>
    <transition>
      <div class="over-artist text-script" :key="overElement.artist.name" v-if="overElement">{{overElement.artist.name}}</div>
    </transition>
  </div>
</template>

<script>
import PhotoExhibitionGridElement from '@/atoms/PhotoExhibitionGridElement'
import MomentumScrolling from '@/atoms/MomentumScrolling'
import Scribbles from '@/molecules/Scribbles'

export default {
  name: 'GalleryGridView',
  components: {
    PhotoExhibitionGridElement,
    MomentumScrolling,
    Scribbles
  },
  data () {
    return {
      overElement: null
    }
  },
  props: {
    elements: {
      type: Array,
      required: true
    },
    twoColumns: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  computed: {
    columns () {
      if (this.$vuetify.breakpoint.mdAndUp) {
        return this.twoColumns ? 2 : 4
      }
      return 1
    }
  },
  methods: {
    onElementClick (element) {
      this.$emit('click', element)
    },
    gridViewColElements (col, maxCols = 4) {
      if (this.elements) {
        const ret = []
        for (let i = col - 1; i < this.elements.length; i += maxCols) {
          ret.push(this.elements[i])
        }
        return ret
      }
      return []
    }
  }
}
</script>

<style lang="scss" scoped>
.over-artist {
  position: fixed;
  top: 50%;
  left: 50%;
  width: 1000%;
  text-align: center;
  transform: translate3d(-50%, -50%, 0);
  font-size: 3vw;
  pointer-events: none;
  color: #000;
}

.grid-element {
  transition: opacity 0.5s $ease-in-out-quad;

  &.deselected {
    opacity: 0.4;
  }
}
</style>
